import PropTypes from "prop-types";
import { getSanityNextImage } from "@lib/getImages";
import styles from "./banner.module.css";

export function Banner({ title, image, altText }) {
  let alt = altText;

  if (!alt) {
    alt = `${title} banner`;
  }

  return (
    <div className={styles.container}>
      {getSanityNextImage(image, { small: "800", medium: "1440", large: "2400" }, alt)}
    </div>
  );
}

Banner.propTypes = {
  title: PropTypes.string,
  image: PropTypes.object.isRequired,
  altText: PropTypes.string.isRequired,
};
